(() => {
  if (customElements.get('alp-quote')) return;
  const KEY = 'portsor-quote-v1';
  const DAY = 86400000;
  const categories = { port: 'Port', ytterdor: 'Ytterdør', innerdor: 'Innerdør', vindu: 'Vindu' };
  const fields = { quantity: 'Antall', room: 'Rom / plassering', measurement: 'Måletype', width: 'Bredde (mm)', height: 'Høyde (mm)', overheight: 'Overhøyde (mm)', depth: 'Fri dybde (mm)', left: 'Sideplass venstre (mm)', right: 'Sideplass høyre (mm)', motor: 'Portmotor', door_package: 'Leveranse', hinge: 'Hengsling', opening: 'Åpningsretning', wall: 'Veggtykkelse (mm)', window_type: 'Åpningstype', material: 'Materiale', brand: 'Fabrikat / modell', color: 'Farge', notes: 'Merknad' };
  class Quote extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.itemForm = this.querySelector('[data-item-form]');
      this.contactForm = this.querySelector('form[id^="QuoteContact-"]');
      this.status = this.querySelector('[data-item-status]');
      this.items = [];
      this.editing = -1;
      this.dirty = false;
      this.category = categories[this.dataset.category] ? this.dataset.category : 'port';
      try {
        const stored = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (stored && stored.version === 1 && Date.now() - stored.updated < 7 * DAY && Array.isArray(stored.items)) {
          this.items = stored.items.filter(item => item && categories[item.category] && item.values && typeof item.values === 'object')
            .slice(0, 30).map(item => ({ category: item.category, values: Object.fromEntries(Object.entries(item.values).filter(([key, value]) => fields[key] && typeof value === 'string').map(([key,value]) => [key, value.slice(0,1500)])) }));
        }
      } catch (_) { this.storageUnavailable = true; }
      if (this.querySelector('[data-success]')) {
        this.items = [];
        try { localStorage.removeItem(KEY); } catch (_) { /* Form success is authoritative. */ }
        this.querySelector('[data-success]').focus();
      }
      this.querySelector('[data-quote-interface]').hidden = false;
      this.selectCategory(this.category);
      this.render();
      this.querySelectorAll('[data-category-button]').forEach(button => button.addEventListener('click', () => {
        if (button.dataset.categoryButton === this.category) return;
        if (this.dirty && !window.confirm('Bytte produkttype? Endringer som ikke er lagt til, blir fjernet.')) return;
        this.reset();
        this.selectCategory(button.dataset.categoryButton);
      }));
      this.itemForm.addEventListener('input', () => { this.dirty = true; this.querySelector('[data-cancel]').hidden = false; });
      this.itemForm.addEventListener('change', () => { this.dirty = true; this.querySelector('[data-cancel]').hidden = false; });
      this.itemForm.addEventListener('submit', event => {
        event.preventDefault();
        if (!this.itemForm.reportValidity()) return;
        if (this.items.length >= 30 && this.editing < 0) { this.status.textContent = 'Listen kan inneholde 30 produktlinjer. Samle like produkter med antall, eller send flere forespørsler.'; return; }
        const values = Object.fromEntries([...new FormData(this.itemForm)].map(([key,value]) => [key, String(value).trim()]));
        const item = { category: this.category, values };
        const editing = this.editing >= 0;
        if (editing) this.items[this.editing] = item;
        else this.items.push(item);
        this.reset();
        this.render();
        this.persist();
        this.status.textContent = (editing ? 'Produktet er oppdatert.' : categories[item.category] + ' er lagt til.') + ' Legg til flere produkter eller send forespørselen.' + (this.storageUnavailable ? ' Nettleseren kan ikke huske listen mellom sider; fullfør forespørselen her.' : '');
      });
      this.querySelector('[data-cancel]').addEventListener('click', () => { this.reset(); this.status.textContent = 'Endringen er avbrutt.'; });
      this.querySelector('[data-clear]').addEventListener('click', () => {
        if (!window.confirm('Vil du tømme hele produktlisten?')) return;
        this.items = []; this.reset(); this.render(); this.persist();
        this.status.textContent = 'Produktlisten er tømt.';
      });
      this.contactForm.addEventListener('submit', event => {
        const error = this.querySelector('[data-submit-error]');
        if (!error) return;
        error.hidden = true;
        if (!this.items.length || this.dirty || this.editing >= 0) {
          event.preventDefault();
          error.hidden = false;
          error.textContent = !this.items.length ? 'Legg til minst ett produkt først.' : 'Du har et produkt som ikke er lagret. Legg det til i forespørselen, eller avbryt endringen før du sender.';
          error.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        this.updateRecap();
        // Native Shopify contact submit handles delivery, spam protection and success.
      });
    }
    selectCategory(category) {
      this.category = category;
      this.querySelectorAll('[data-category-button]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.categoryButton === category)));
      this.querySelectorAll('[data-guide]').forEach(guide => { guide.hidden = guide.dataset.guide !== category; });
      this.querySelectorAll('[data-fields]').forEach(group => { const active = group.dataset.fields.split(' ').includes(category); group.hidden = !active; group.disabled = !active; });
      const measurement = this.itemForm.elements.measurement;
      [...measurement.options].forEach(option => {
        option.disabled = (category === 'port' && option.value !== 'Åpningsmål' && option.value !== 'Ukjent') || (option.value === 'Dørbladmål' && category !== 'innerdor');
        option.hidden = option.disabled;
      });
      if (measurement.selectedOptions[0].disabled) measurement.value = 'Åpningsmål';
    }
    reset() {
      this.itemForm.reset(); this.editing = -1; this.dirty = false;
      const error = this.querySelector('[data-submit-error]'); if (error) error.hidden = true;
      this.querySelector('[data-add]').textContent = 'Legg til i forespørselen';
      this.querySelector('[data-cancel]').hidden = true;
      this.selectCategory(this.category);
    }
    persist() {
      try { localStorage.setItem(KEY, JSON.stringify({ version: 1, updated: Date.now(), items: this.items })); }
      catch (_) { this.storageUnavailable = true; }
    }
    describe(item) {
      return Object.entries(fields).filter(([key]) => item.values[key]).map(([key,label]) => label + ': ' + item.values[key]).join('\n');
    }
    updateRecap() {
      const recap = this.querySelector('[data-recap]');
      if (recap) recap.value = this.items.map((item,index) => `${index + 1}. ${categories[item.category]}\n${this.describe(item)}`).join('\n\n');
    }
    render() {
      const list = this.querySelector('[data-items]'); list.replaceChildren();
      this.items.forEach((item,index) => {
        const li = document.createElement('li');
        const title = document.createElement('strong'); title.textContent = `${index + 1}. ${categories[item.category]} · ${item.values.quantity || '1'} stk.`;
        const details = document.createElement('p'); details.className = 'alp-quote__item-details'; details.textContent = this.describe(item);
        const disclosure = document.createElement('details');
        const summary = document.createElement('summary'); summary.textContent = item.values.width && item.values.height ? item.values.width + ' × ' + item.values.height + ' mm – vis detaljer' : 'Vis spesifikasjoner';
        disclosure.append(summary, details);
        const actions = document.createElement('div'); actions.className = 'alp-quote__item-actions';
        const edit = document.createElement('button'); edit.type = 'button'; edit.textContent = 'Rediger'; edit.setAttribute('aria-label', `Rediger produkt ${index + 1}`);
        edit.addEventListener('click', () => {
          if (this.dirty && !window.confirm('Forkaste endringen som ikke er lagret?')) return;
          this.reset(); this.selectCategory(item.category); this.editing = index;
          Object.entries(item.values).forEach(([key,value]) => { if (this.itemForm.elements[key]) this.itemForm.elements[key].value = value; });
          this.querySelector('[data-add]').textContent = 'Lagre endring'; this.querySelector('[data-cancel]').hidden = false;
          this.itemForm.elements.quantity.focus(); this.itemForm.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Fjern'; remove.setAttribute('aria-label', `Fjern produkt ${index + 1}`);
        remove.addEventListener('click', () => {
          this.items.splice(index,1);
          if (this.editing === index) this.reset(); else if (this.editing > index) this.editing--;
          this.render(); this.persist(); this.status.textContent = 'Produktet er fjernet.';
          const next = this.querySelector('[data-items] button') || this.querySelector('[data-add]'); next.focus();
        });
        actions.append(edit,remove); li.append(title,disclosure,actions); list.append(li);
      });
      this.querySelector('[data-count]').textContent = `(${this.items.length})`;
      this.querySelector('[data-empty]').hidden = !!this.items.length;
      this.querySelector('[data-clear]').hidden = !this.items.length;
      const send = this.querySelector('[data-send]'); if (send) send.disabled = !this.items.length;
      this.updateRecap();
    }
  }
  customElements.define('alp-quote', Quote);
})();
